import React from "react";
import {
  PieChart,
  Pie,
  Legend,
  Cell,
  Tooltip,
} from "recharts";
import commonFunctions from "../../common/Functions";

const ChartComponent = ({ data, type, barColors }) => {
  const tooltip = ({ active, payload, label }) => {
    if (active) {
      let obj = data.filter((item) => {
        return item.name === payload[0].name;
      });

      if (obj && obj[0]) {
        return (
          <div
            className="custom-tooltip"
            style={{
              backgroundColor: "#ffff",
              padding: "5px",
              border: "1px solid #cccc",
            }}
          >
            <label>
              {payload[0].name} : {commonFunctions.CommaFormatted(payload[0].value)} {obj[0].currency || ''}
            </label>
          </div>
        );
      }
    }
    return null;
  };

  if (!data || data.length === 0) {
    return null;
  }

  return (
    <div className="chart-container mb-4">
      <h5 className="chart-title">
        {type === 'invoices' ? 'Invoices' : 'Transactions'} by Account
      </h5>
      <PieChart width={730} height={300}>
        <Pie
          data={data}
          color="#000000"
          dataKey="value"
          nameKey="name"
          cx="50%"
          cy="50%"
          outerRadius={120}
          fill="#8884d8"
        >
          {data.map((entry, index) => (
            <Cell
              key={`cell-${index}`}
              fill={barColors[index % barColors.length]}
            />
          ))}
        </Pie>
        <Tooltip content={tooltip} />
        <Legend layout="vertical" verticalAlign="top" align="left" />
      </PieChart>
    </div>
  );
};

export default ChartComponent; 